import FieldGroups from '@/pages/fieldGroupAdmin/FieldGroupAdmin.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/field-groups')({
  component: () => <FieldGroupsLayout />,
})

const FieldGroupsLayout = () => {
  return (
    <>
      <FieldGroups />
      <Outlet />
    </>
  )
}
